/**
 * @generated SignedSource<<1fa6cc0a0240fd37999ccbf7b357112b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegionSelect_data$data = {
  readonly regions: ReadonlyArray<{
    readonly country: {
      readonly id: string;
    };
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "RegionSelect_data";
};
export type RegionSelect_data$key = {
  readonly " $data"?: RegionSelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RegionSelect_data">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RegionSelect_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Region",
      "kind": "LinkedField",
      "name": "regions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Country",
          "kind": "LinkedField",
          "name": "country",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "58e62b7c9a3b87f6c46b5da96fabc836";

export default node;
